export const locations = {
    au: 1,
    ca: 2,
    uk: 3,
    nz: 4
}